module.exports = __webpack_public_path__ + "img/22.6d47610f.jpg";